import { Component, type ReactNode } from "react";
import { AlertCircle, RotateCcw } from "lucide-react";

/** A failed application must not take down unrelated windows or the shell. */
export class AppWindowBoundary extends Component<{ title: string; onClose: () => void; children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  render() {
    if (!this.state.failed) return this.props.children;
    return <section className="app-failure" role="alert">
      <AlertCircle size={30} aria-hidden="true" />
      <h2>Não foi possível abrir {this.props.title}</h2>
      <p>Os outros aplicativos continuam disponíveis. Você pode tentar abrir esta janela novamente.</p>
      <div><button className="primary-button compact" type="button" onClick={() => this.setState({ failed: false })}><RotateCcw size={16} />Tentar abrir novamente</button><button className="secondary-button" type="button" onClick={this.props.onClose}>Fechar aplicativo</button></div>
    </section>;
  }
}
